import { CheckoutAPIRedirectData } from '@is24/is24-checkout-js/dist/@types/models/checkout-api-redirect-data';

export enum Product {
  WOHNEN_LIGHT = 'WOHNEN_LIGHT',
}

export interface UpsellPurchaseResponse {
  productGranted: boolean;
  alreadyEntitled: boolean;
  inProgress: boolean;
  transactionId: string;
  checkoutRedirectData?: CheckoutAPIRedirectData;
}
